import React from 'react'

function MaestrosSumary() {
  return (
    <div>MaestrosSumary</div>
  )
}

export default MaestrosSumary